module.exports = __webpack_public_path__ + "img/Max.a6a03dd7.jpg";